import { TextSpan } from '../../../Atoms/Text';
import { AdviseSupplierInvoice } from '../../../../types/advise';

const lineItemCount = (count: number) => `${count} line item${count === 1 ? '' : 's'}`;

const statusLabel = ({ status, line_items }: AdviseSupplierInvoice) => {
  if (status === 'parsed') return `Parsed · ${lineItemCount(line_items.length)}`;
  if (status === 'manual') return `Manual · ${lineItemCount(line_items.length)}`;
  return 'Needs manual entry';
};

/** Whether nothing has been read from or entered for the invoice yet. */
export const needsManualEntry = (invoice: AdviseSupplierInvoice) => invoice.status === 'needs_manual_entry';

/** The invoice's status: amber while it needs manual entry, green once its line items are in. */
export const InvoiceStatusPill = ({ invoice }: { invoice: AdviseSupplierInvoice }) => {
  const pending = needsManualEntry(invoice);
  return (
    <TextSpan
      size="xs"
      weight="medium"
      color={pending ? 'amber' : 'green600'}
      className={`whitespace-nowrap rounded-full px-2.5 py-1 ${pending ? 'bg-amber-50' : 'bg-green-50'}`}>
      {statusLabel(invoice)}
    </TextSpan>
  );
};
